import Vue from 'vue'
import Vuex from 'vuex'
import { isEmpty } from 'lodash'

import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { DadosCobranca, DadosPessoais, Endereco } from '@finx/web-repository/src/types/DadosCobranca'

Vue.use(Vuex)

const dadosPessoais: DadosPessoais = {
  nome: '',
  cpfCnpj: '',
}

const endereco: Endereco = {
  bairro: '',
  cep: '',
  cidade: '',
  complemento: '',
  logradouro: '',
  numero: '',
  uf: '',
}

const dadosCobranca: DadosCobranca = {
  pessoa: dadosPessoais,
  endereco: endereco,
}

const getters = {
  DADOS_COBRANCA: (state: any) => {
    return state.dadosCobranca
  },
}

const actions = {}

const mutations = {
  DADOS_COBRANCA (context: any, dadosCobranca) {
    context.dadosCobranca = dadosCobranca
  },
}

export default new Vuex.Store({
  state: {
    dadosCobranca: dadosCobranca,
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
})
